import { VOICEOVER_COVERAGE_TYPES } from "./const";

export const getItemOverlappedBy = (inputData, segments) => {
    if (!segments?.length) {
        return null;
    }

    const coverage = segments?.map((item) => {
        let coverage = null;
        const { start, end } = item;
        if (inputData.start >= start && inputData.end <= end) {
            coverage = VOICEOVER_COVERAGE_TYPES.FULL;
        } else if (inputData.start >= start && inputData.start <= end) {
            coverage = VOICEOVER_COVERAGE_TYPES.START;
        } else if (inputData.start < start && inputData.end > end) {
            coverage = VOICEOVER_COVERAGE_TYPES.INTERMEDIATE;
        } else if (inputData.end >= start && inputData.start < start && inputData.end < end) {
            coverage = VOICEOVER_COVERAGE_TYPES.END;
        }
        return { ...item, coverage };
    }).filter(item => item.coverage !== null)
    return coverage;
};

export const checkForFullCoverage = (coverageArray) => coverageArray ? coverageArray?.some(({ coverage = null }) => coverage === VOICEOVER_COVERAGE_TYPES.FULL) : false;